module.exports = __webpack_public_path__ + "static/media/12.1aa2ccad.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/12.png
// module id = 1197
// module chunks = 0